import {
  type ShimBackgroundTypeValue,
  ShimLayer,
} from '@volkswagen-onehub/components-core';
import {ShimBackgroundTypeV2} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';

import {getShimColor} from './utils';

const shimBackgroundTypeMap: {
  [key in ShimBackgroundTypeV2]: ShimBackgroundTypeValue;
} = {
  [ShimBackgroundTypeV2.OPAQUE]: 'opaque',
  [ShimBackgroundTypeV2.TRANSPARENT]: 'transparent',
};

export interface ShimProps {
  readonly backgroundType?: ShimBackgroundTypeV2;
  readonly layerType: string;
  onClick?(): void;
}

export const Shim: React.FunctionComponent<ShimProps> = (props) => {
  const {onClick, backgroundType, layerType, ...ownProps} = props;
  const shimBackgroundType = backgroundType
    ? shimBackgroundTypeMap[backgroundType]
    : undefined;

  return (
    <ShimLayer
      {
        ...ownProps /* Used to pass through the animation props */
      }
      key="shim"
      backgroundType={getShimColor(layerType, shimBackgroundType)}
      onClick={onClick}
    />
  );
};
